import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Dialog, Slide } from '@material-ui/core';
import useMediaQueries from 'hooks/useMediaQueries';

const useStyles = makeStyles((theme) => ({
    paper: {
        position: 'relative',
        background: theme.palette.common.white,
        overflowX: 'hidden',
        margin: 0,
        // maxWidth: 700,
        '& .MuiDialogContent-root': {
            paddingLeft: 0,
            paddingRight: 0
        }
    },
    closeIcon: {
        position: 'absolute',
        top: 10,
        right: 10,
        cursor: 'pointer',
        zIndex: 10
    },
    mobilePadding: {
        paddingLeft: 10,
        paddingRight: 10,
        [theme.breakpoints.down('sm')]: {
            paddingLeft: 0,
            paddingRight: 0
        }
    }
}));

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

function DialogBase({ onClose, padding = 20, isForm = false, children, ...rest }) {
    const classes = useStyles({ padding });
    const { isMobile } = useMediaQueries();

    return (
        <Dialog
            classes={{ paper: `${classes.paper} ${rest?.className} ${isMobile ? classes.mobilePadding : ''}` }}
            onClose={onClose}
            TransitionComponent={Transition}
            {...rest}
        >
            {children}
        </Dialog>
    );
}

export default React.memo(DialogBase);
